import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _isNil from "lodash/isNil";
import _forEach from "lodash/forEach";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import 'highlight.js/styles/solarized-dark.css';
import React from 'react'; // @ts-expect-error ts-migrate(7016) FIXME: Try `npm install @types/react-highlight` if it exi... Remove this comment to see the full error message

import Highlight from 'react-highlight/lib/optimized';
import xss, { whiteList } from 'xss';
import './index.scss'; // languages that are aliases for any of these are also supported
// (e.g. html is an alias of xml)
// only module names of highlight.js can be listed to make webpack work

import { jsx as ___EmotionJSX } from "@emotion/react";
export var highlightLanguages = ['python', 'r', 'sql', 'xml', 'scala', 'bash', 'json', 'shell', 'yaml', 'julia'];
var defaultProps = {
  className: '',
  customTag: 'div',
  extraClass: '',
  mathJaxEnabled: false,
  syntaxHighlighting: false,
  unsafe: false
};

var HTMLContent = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(HTMLContent, _React$PureComponent);

  var _super = _createSuper(HTMLContent);

  function HTMLContent(props) {
    var _this;

    _classCallCheck(this, HTMLContent);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "ref", void 0);

    _this.ref = React.createRef();
    return _this;
  }

  _createClass(HTMLContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.renderMathJax();
      this.setLinksAttributes();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.renderMathJax();
      this.setLinksAttributes();
    }
  }, {
    key: "setLinksAttributes",
    value: function setLinksAttributes() {
      if (!_isNil(this.ref.current)) {
        _forEach(this.ref.current.getElementsByTagName('a'), function (el) {
          el.setAttribute('target', '_blank');
          el.setAttribute('rel', 'noopener noreferrer');
        });
      }
    }
  }, {
    key: "renderMathJax",
    value: function renderMathJax() {
      var _this2 = this;

      var mathJaxEnabled = this.props.mathJaxEnabled;

      if (mathJaxEnabled) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'MathJax' does not exist on type 'Window ... Remove this comment to see the full error message
        var _window = window,
            MathJax = _window.MathJax,
            _Promise = _window.Promise;

        if (_isNil(MathJax)) {
          if ("production" !== 'test') {
            // eslint-disable-next-line no-console
            console.warn('No MathJax instance globally exposed.');
          }
        } else if (_isNil(_Promise)) {
          // eslint-disable-next-line no-console
          console.warn('Promise support needed');
        } else {
          // typesetPromise is only available once MathJax loaded
          MathJax.startup.promise.then(function () {
            if (!_isNil(_this2.ref.current)) {
              MathJax.typesetPromise([_this2.ref.current]);
            }
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Tag = _this$props.customTag,
          extraClass = _this$props.extraClass,
          html = _this$props.html,
          syntaxHighlighting = _this$props.syntaxHighlighting,
          unsafe = _this$props.unsafe;
      var content = unsafe ? html : xss(html, {
        stripIgnoreTag: true,
        stripIgnoreTagBody: true,
        whiteList: _objectSpread(_objectSpread({}, whiteList), {}, {
          summary: []
        })
      });

      if (syntaxHighlighting) {
        return (// @ts-expect-error ts-migrate(2322) FIXME: Property 'children' does not exist on type 'Intrin... Remove this comment to see the full error message
          ___EmotionJSX(Tag, {
            className: extraClass,
            ref: this.ref
          }, ___EmotionJSX(Highlight, {
            className: "dc-html-content-syntax-highlight",
            innerHTML: true,
            languages: highlightLanguages
          }, content))
        );
      }

      return ___EmotionJSX(Tag // @ts-expect-error ts-migrate(2322) FIXME: Property 'className' does not exist on type 'Intri... Remove this comment to see the full error message
      , {
        className: extraClass,
        dangerouslySetInnerHTML: {
          __html: content
        },
        ref: this.ref
      });
    }
  }]);

  return HTMLContent;
}(React.PureComponent);

_defineProperty(HTMLContent, "defaultProps", defaultProps);

export default HTMLContent;